module.exports = __webpack_public_path__ + "img/GBWhatsApp.95bbff8b.webp";